import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "About the Diploma", id: "about-diploma" },
    { name: "Objectives", id: "objectives" },
    { name: "Time Table", id: "timetable" },
    { name: "Achievements", id: "achievements" },
    { name: "Contact", id: "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>Indian Vastu Shastra is a treatise that expounds on the comprehensive construction methods and processes of buildings. This science originated from Sthapatya Veda, which is famous as an Upaveda (sub-Veda) of Atharvaveda. It is the science of architecture that combines the five fundamental elements of nature (earth, water, fire, air, and sky) and establishes harmony between them and human beings and materials. It works for the health, wealth, happiness, and prosperity of living beings residing in Vastu-compliant buildings. In a mantra of Rigveda, the Vedic sage prays to Vastoshpati to keep him under his protection and to bestow blessings for prosperous living. The sage also wishes for auspicious blessings from Vastoshpati for his bipeds (humans) and quadrupeds (animals). As follows:</p>
            <p><strong>Vāstoshpate prati jānīhyasmāntsvāvesho anamīvo bhavā naḥ.</strong></p>
            <p><strong>Yat tvemahe prati tanno juṣasva śaṃ no bhava dvipade śaṃ chatuṣpade. || Rigveda - 7/54/1</strong></p>
            <p>The tradition of Sthapatya Shastra, starting from Sthapatyaveda, the Upaveda of Atharvaveda, reached its most flourishing state in the Puranic period. In Matsya Purana, Bhrigu, Atri, Vasistha, Vishwakarma, Maya, Narada, Nagnajit, Vishalākṣa, Purandara, Brahma, Kumara, Nandisha, Shaunaka, Garga, Vasudeva, Aniruddha, Shukra, and Brihaspati are said to be the 18 preceptors of Sthapatya Shastra. Among these preceptors, Vishwakarma is considered the chief exponent of the Nagara tradition, and Maya of the Dravida tradition. Additionally, ample descriptions of architecture are found in Agni Purana, Garuda Purana, Vishnudharmottara Purana, etc., as well as in Grihyasutras, Agam Granthas, Tantrasamuchchaya and other Tantric texts, and Brihatsamhita and other astrological texts.</p>
            <p>In the epic Ramayana, beautiful creations like the royal palace of Lanka and Ashokavatika are found. In Mahabharata, descriptions of buildings such as the city of Indraprastha, the assembly hall, Dwarkapuri created by Vishwakarma, and the Lakshagriha (house of lac) built by the Kauravas are found. Based on archaeological literature, the town planning of the Indus Valley Civilization is a matter of surprise for archaeologists, and the description of Mauryan buildings and the Sudarshan Lake is also historically famous. Ancient Hindu rulers' beautiful palaces and forts, along with various temples of Greater India, and the forts of medieval Rajput kings, give us knowledge of our rich architectural tradition. Thus, in the Indian knowledge tradition, not only spirituality but also art, science, and technology are extensively described.</p>
            <p>Later, independent treatises on Sthapatya Shastra were composed. Among these, Vishwakarmaprakasha, Aparajitaprichchha, Jayaprichchha, Manasara, Pramanamajali, Vishwakarmavastushastra, Prasadamanana, Vasturatnakara, Vastusara, Brihatvastumala, Vasturatnavali, Rajavallabhavastushastra, Vastumandanam, Samarangana Sutradhar, Devalayachandrika, Manushyalayachandrika, Rupamandanam, Mayamatam, etc., are prominent texts based on the Indian architectural tradition. These texts extensively describe the Indian architectural tradition.</p>
            <p>Vastu Shastra is especially helpful in making the way of life easy and simple. In the Indian Sanatana tradition, house construction is considered essential for every human being; without a house, the Grihastha ashrama (householder's stage of life) cannot be complete. The very root of the householder's ashrama is the house. Therefore, every person undertakes this work, and it is also necessary that the house adheres to Vastu Shastra rules. In this fast-paced life, a home is essential for rest, where one can forget all the fatigue of their busy life and rest peacefully. That home should be conducive to happiness and prosperity, where there is family harmony, and it should also be materially rich, with a good inclusion of the five great elements. Therefore, to achieve all these, it is essential that house construction is done based on Vastu Shastra principles.</p>
            <p>Currently, for the study of Vastu Shastra principles, a Vastu Shastra Diploma is conducted at Maharishi Valmiki Sanskrit University, Kaithal. However, in the near future, there are plans to expand it and include ancient Indian sculpture, architecture, designing, painting, etc., as well as modern architecture, and to establish a Department of Vastu Shastra at the university.</p>
        </>
    ),
    "objectives": (
        <>
            <h6>Objectives:</h6>
            <ol>
                <li>**Knowledge of Vastu Shastra Principles:** To provide students with knowledge about the fundamental principles of Vastu Shastra, directions, five elements, and the flow of energy.</li>
                <li>**Harmony in Building and Home Design:** To teach students how homes and buildings can provide a pleasant, prosperous, and healthy environment by following Vastu Shastra.</li>
                <li>**Utilization of Natural Resources:** To train students on construction in harmony with natural resources and the environment.</li>
                <li>**Integration of Vastu Shastra in Modern Architecture:** To teach students how Vastu Shastra principles can be incorporated into modern architecture and design.</li>
                <li>**Understanding Vastu Shastra's Effects:** To explain the effects of Vastu Shastra on the health, prosperity, and mental peace of buildings and other structures.</li>
                <li>**Development of Professional Skills:** To provide students with professional and technical skills so that they are prepared to work in the field of Vastu Shastra, whether related to design, consulting, or construction.</li>
            </ol>
            <p>This diploma course is particularly suitable for those who are interested in the fields of architecture, construction, and design, and who wish to understand the principles of traditional Indian architecture and apply them in their work.</p>
            <p>Dr. Govind Vallabh</p>
            <p>Coordinator, Vastu Shastra Diploma</p>
        </>
    ),
    "timetable": (
        <>
            <p>Content not available.</p>
        </>
    ),
    "achievements": (
        <>
            <p>Content not available.</p>
        </>
    ),
    "contact": (
        <>
            <p>Dr. Govind Vallabh</p>
            <p>Coordinator, Vastu Shastra Diploma</p>
            <p>Mobile – 70115-04209</p>
            <p>Email – govindballabh92k@gmail.com</p>
        </>
    )
};

export default function VastuShastraDiploma_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeId, setActiveId] = useState(departments[0].id);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setActiveId(deptId);
        setCurrentContent(contentData[deptId]);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">Vastu Shastra Diploma</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id
                                ? "bg-primary text-white"
                                : "bg-white text-dark"
                                }`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <h5>Main Content</h5>
                <div>{currentContent}</div>
            </main>
        </div>
    );
}